import { useQuery } from "react-query";
import ORM, { BaseModel } from "./orm";
import { SingleRecordResponse } from "@services/api/api.service";

export interface DashboardFilterOptionColumnReference {
    pipeline_node_id: string;
    field_id: string;
}

export interface DashboardDateRange {
    date_range?: string;
    custom_date_range_start?: string;
    custom_date_range_end?: string;
    user_timezone?: string;
}

export interface DashboardFilterOption {
    column_references?: DashboardFilterOptionColumnReference[];
    filter_type: 'QUERY_LIST' | 'STATIC_LIST' | 'FREE_TEXT' | 'DIMENSION' | 'DATE_RANGE';
    comparator: string;
    query_list_node_id?: string;
    query_list_field_id?: string;
    static_list?: string[];
    allow_multiple?: boolean;
    default_value?: string|string[];
    dimension_id?: string;
}


export type DashboardObjectType = undefined | 'NODE' | 'VISUALIZATION' | 'MARKDOWN' | 'FILTER' | 'ANALYSIS';

export interface DashboardComponent {
    id: string;
    title: string;
    x: number;
    y: number;
    width: number;
    height: number;
    object_id: string;
    object_type?: DashboardObjectType;
    markdown_content?: string;
    filter_config?: DashboardFilterOption;
    column_whitelist?: string[];
    ignore_date_range?: boolean;
    
    
}

export interface EmailNotificationUser {
    email: string;
    added_at: string;
    added_by: string;
    unsubscribed: boolean;
  }

export interface DashboardNotifications extends BaseModel {
    email_users: EmailNotificationUser[];
}


export interface Dashboard extends BaseModel {
    name: string;
    description: string;
    components: DashboardComponent[];
    date_range_config?: DashboardDateRange;
}

export class _DashboardORM extends ORM<Dashboard>{
    public async getNotifications(dashboardId: string) {
            const result = await this.apiService.request('GET', `/${this.endpoint}/${dashboardId}/notifications`) as SingleRecordResponse<DashboardNotifications>;
            return result.record;
        }
        public async addNotificationUser(dashboardId: string, email: string) {
            const result = await this.apiService.request('POST', `/${this.endpoint}/${dashboardId}/add-email-notifications-user`, {email}) as SingleRecordResponse<any>;
            return result.record;
        }
    
        public async removeNotificationUser(dashboardId: string, email: string) {
            const result = await this.apiService.request('POST', `/${this.endpoint}/${dashboardId}/remove-email-notifications-user`, {email}) as SingleRecordResponse<any>;
            return result.record;
        }

        public async sendNotificationsNow(dashboardId: string) {
            const result = await this.apiService.request('POST', `/${this.endpoint}/${dashboardId}/send-notifications`, {}) as SingleRecordResponse<any>;
            return result.record;
        }
};



export const DashboardORM = new _DashboardORM('dashboards');

export const useDashboards = () => {
    return useQuery(['dashboards'], async () => {
        const result = await DashboardORM.find({});
        return result.records;
    });
}

export const useDashboard = (dashboardId: string) => {
    return useQuery(['dashboards', dashboardId], async () => {
        if (!dashboardId) {
            return undefined;
        }
        const result = await DashboardORM.findById(dashboardId);
        return result;
    })
}
